import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

type ForbiddenAlertIconProps = {
  backgroundColor: string
} & IconSvgProps

export function ForbiddenAlertIcon({ backgroundColor, color, ...props }: ForbiddenAlertIconProps) {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="50" height="50" rx="25" fill={backgroundColor} />
      <path
        d="M32.2465 17.7701C30.3124 15.8351 27.7374 14.769 24.9976 14.769C19.3458 14.769 14.7476 19.3673 14.7476 25.019C14.7476 27.7589 15.8136 30.3339 17.7486 32.268C19.6827 34.2031 22.2577 35.269 24.9976 35.269C30.6493 35.269 35.2476 30.6708 35.2476 25.019C35.2476 22.2792 34.1816 19.7042 32.2465 17.7701ZM15.6389 25.019C15.6389 19.8584 19.8369 15.6603 24.9976 15.6603C27.3497 15.6603 29.5611 16.5294 31.2857 18.0998L18.0784 31.3072C16.5079 29.5825 15.6389 27.3712 15.6389 25.019ZM24.9976 34.3778C22.6454 34.3778 20.4341 33.5087 18.7094 31.9383L31.9168 18.7309C33.4872 20.4556 34.3563 22.6669 34.3563 25.0191C34.3563 30.1797 30.1582 34.3778 24.9976 34.3778Z"
        fill={color}
        stroke={color}
        strokeWidth="0.8"
      />
    </svg>
  )
}
